import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 48 48" fill="none" {...props}>
      <title>{props.title || 'Unique'}</title>
      <g>
        <path
          d="M24 0C37.2857 0 48 10.7143 48 24C48 37.2857 37.2857 48 24 48C10.7143 48 0 37.2857 0 24C0 10.7143 10.7143 0 24 0Z"
          fill="#BEEBF6"
        />
        <path
          d="M31.4657 24.0004V22.9338C31.4451 21.7782 32.3638 20.8239 33.5194 20.8006C35.3475 20.8237 37.0983 20.0637 38.33 18.7125C39.5616 17.3613 40.1565 15.5478 39.9646 13.7296C39.5209 10.405 36.6553 7.94124 33.3018 8.00107H25.066C20.3534 8.00107 16.533 11.8214 16.533 16.5341V22.9338C16.533 25.1969 15.634 27.3673 14.0337 28.9676C12.4335 30.5678 10.2631 31.4668 8 31.4668C8 36.1795 11.8204 39.9998 16.533 39.9998"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.1573 31.9162C21.3862 32.8005 20.4561 34.787 20.911 36.7136C21.3659 38.6403 23.0862 40.0009 25.0659 39.9997H34.6655C35.2546 39.9997 35.7321 39.5222 35.7321 38.9331C35.7321 36.5768 33.8219 34.6666 31.4656 34.6666V29.3335"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.7304 12.1724L12.282 15.8131C12.0149 15.9903 11.8416 16.2783 11.8102 16.5973C11.7788 16.9164 11.8925 17.2326 12.1199 17.4586L16.5286 21.8673L11.5838 23.517C11.253 23.6274 10.9972 23.8925 10.8986 24.227C10.7999 24.5614 10.871 24.9229 11.0888 25.1951L14.0754 28.9269"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.2661 24.0004H32.5326C34.9651 24.0003 37.0896 25.6457 37.6979 28.0009C37.7802 28.3204 37.71 28.66 37.5077 28.9207C37.3054 29.1814 36.9939 29.3338 36.664 29.3335H28.2661"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.5425 12.2705C25.8357 12.2398 26.0985 12.4523 26.1298 12.7455"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.0685 12.8577C25.0534 12.717 25.0948 12.5761 25.1836 12.4659C25.2724 12.3558 25.4014 12.2854 25.5421 12.2704"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.6548 13.3342C25.3623 13.3649 25.1002 13.153 25.0688 12.8606"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1327 12.7454C26.1474 12.8861 26.1057 13.0268 26.0166 13.1367C25.9275 13.2466 25.7984 13.3166 25.6577 13.3313"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.632 16.5341H33.5991"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </Icon>
  )
}
